import PayMethodForm from './PayMethodForm';
import { reportError } from '../../errorReporter';

jest.mock('../../errorReporter', () => ({ reportError: jest.fn() }));

describe('PayMethodForm#handleCreditCardResponse', () => {
  let form;

  beforeEach(() => {
    reportError.mockClear();
    form = {
      props: {
        i18n: { credit_card: { error_messages: { e_500: 'System Error. Try again' } } },
        onError: jest.fn()
      }
    };
  });

  it('reports a failed tokenization request and shows an error', () => {
    PayMethodForm.prototype.handleCreditCardResponse.call(form, {
      response: 'e_500',
      transportError: true,
      status: 0,
      textStatus: 'error'
    });

    expect(form.props.onError).toHaveBeenCalledWith('System Error. Try again');
    expect(reportError).toHaveBeenCalledWith(
      expect.any(Error),
      { credit_card_tokenization: { status: 0, textStatus: 'error' } }
    );
  });

  it('does not report a gateway decline', () => {
    PayMethodForm.prototype.handleCreditCardResponse.call(form, { code: 3, message: 'Invalid card' });

    expect(reportError).not.toHaveBeenCalled();
  });
});
